import { IPassengerEnvironment } from '@mopla/utils';

export const environment: IPassengerEnvironment = {
	production: true,
	baseUrl: 'https://backend.pullrequest.mopla.solutions/pr-5457',
	sentryDns:
		'https://6178e46eb58a27c59aed5eedf11915aa@o1355916.ingest.us.sentry.io/6643623',
	env: 'pullrequest',
	ticketshopBaseUrl: 'https://ticketshop.staging.mopla.solutions',
	paymentBaseUrl: 'https://payment.pullrequest.mopla.solutions',
	stripePublicKey:
		'pk_test_51Tiy8gBFmXsmP8wAKCDNObdSF5C6nTBWKAL2Nch6eQuyB8tMMFGDbLNsx3VYlblx9pYtUZuQNLkXWbUjFi7EILEk00KascO143',
	stripeCustomCloseCallback: 'mopla.passenger.staging://?isPaymentRedirect',
	stripeWebCallback: 'https://app.pullrequest.mopla.solutions',
	stripeNativeCallback: 'https://payment.pullrequest.mopla.solutions',
	firebaseConfig: {
		apiKey: 'AIzaSyBwes4dXu5n5WBi71hErW9LD9BSDmthzdQ',
		authDomain: 'mopla-staging.firebaseapp.com',
		projectId: 'mopla-staging',
		storageBucket: 'mopla-staging.appspot.com',
		messagingSenderId: '704166027041',
		appId: '1:704166027041:web:020d999e262f3749d56860',
	},
	spenditValidationSetSource:
		'https://staging.mybenefits.spendit.de/.well-known/openid-configuration',
	showLiveUpdatesVersion: true,
	trueLayerRedirectUrl:
		'https://app.pullrequest.mopla.solutions/?truelayer_redirect=true',
	trueLayerDeepLink:
		'mopla.passenger.staging://auth-callback?truelayer_redirect=true',
	trueLayerAuthLinkWeb:
		'https://auth.truelayer-sandbox.com/?response_type=code&client_id=sandbox-moplapassenger-0e0708&scope=verification&providers=uk-cs-mock%20uk-ob-all%20uk-oauth-all&redirect_uri=https://app.pullrequest.mopla.solutions/?truelayer_redirect=true',
	trueLayerAuthLinkNative:
		'https://auth.truelayer-sandbox.com/?response_type=code&client_id=sandbox-moplapassenger-0e0708&scope=verification&providers=uk-cs-mock%20uk-ob-all%20uk-oauth-all&redirect_uri=mopla.passenger.staging://auth-callback?truelayer_redirect=true',
	enableOpenBanking: true,
	basename: '',
	recaptchaSiteKey: '6Ld0h3wrAAAAACNw1u2LZZ8jvpiop12lr_l1k22r',
	deutschlandTicket: {
		priceChangeDate: '2026-01-01',
		oldPrice: 58,
		newPrice: 63,
		messageVisibleFrom: '2025-11-01',
		messageVisibleUntil: '2026-02-01',
	},
	featureFlags: {
		PRODTVouchersFeatureFlag: true,
		/** TODO: MC-11549 - fill with the real ÖPNV-Flex distributor id from the dev backend */
		priorityDistributorIds: [],
	},
	googleTagManager: {
		googleTagManagerContainerId: 'GTM-W85G5NR8',
	},
	// TODO: Re-enable 'facebook' login after fixing iOS authentication issue.
	// Also requires Firebase configuration for production environment.
	allowedSocialLoginMethods: ['google', 'apple'],
};
